import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { HhsgSharedUserProfile } from '../../../models';
import { HhsgSharedClient } from '../../../models/client.model';
import { HhsgSharedStuderEmployee } from '../../../models/sgportal-data-api-models/employee.model';
import { HhsgSharedStuderOrganization } from '../../../models/sgportal-data-api-models/organization.model';
import { HhsgSharedStuderState } from '../../../models/sgportal-data-api-models/state.model';
import { HhsgSharedStuderOrganizationService, HhsgSharedUserService } from '../../../services';
import { RoleUtil } from '../../../utilities/role.util';

@Component({
	selector: 'edit-organization',
	templateUrl: 'edit-organization.component.html',
	styleUrls: ['edit-organization.component.scss']
})

export class HhsgSharedStuderEditOrganizationComponent implements OnInit, OnDestroy {
	constructor(
        public _organizationService: HhsgSharedStuderOrganizationService,
        public _userService: HhsgSharedUserService) { }

	selectedOrganization: HhsgSharedStuderOrganization;
	showMinimumFields: boolean;
	IsVMorLEMSelected: boolean;
	hideStuderLinks: boolean;
	departmentCount: number;
	divisionCount: number;
	facilityCount: number;
	jobTitleCount: number;
	currentClient: HhsgSharedClient;
	currentUser: HhsgSharedUserProfile;
	private _unsubscribe$ = new Subject<void>();

	@Input('currentOrganization') set currentOrganization(organization: HhsgSharedStuderOrganization) {
		this.selectedOrganization = organization;
		this._organizationService.currentOrganization = organization;
	}
	@Input() set setStates(states: HhsgSharedStuderState[]) {
		this.states = states;
	}
	@Input('showMinFields') set showMinFields(showMin: boolean) {
		this.showMinimumFields = showMin;
	}
	@Input('deptCount') set deptCount(deptCount: number)  {
		this.departmentCount = deptCount;
	}
	@Input('divCount') set divCount(divCount: number) {
		this.divisionCount = divCount;
	}
	@Input('jobCount') set jobCount(jobTitleCount: number) {
		this.jobTitleCount = jobTitleCount;
	}
	@Input('facCount') set facCount(facCount: number) {
		this.facilityCount = facCount;
	}

	@Input('currClient') set currClient(client: HhsgSharedClient) {
		this.currentClient = client;
	}

	@Output() cancelEdit = new EventEmitter<void>();
	@Output() isEdited = new EventEmitter<boolean>();

	leaders: HhsgSharedStuderEmployee[];
	errorMessage: string;
	states: HhsgSharedStuderState[];

	ngOnInit(): void {
		this._userService.getUserProfile()
            .pipe(takeUntil(this._unsubscribe$))
			.subscribe(async (userProfile: HhsgSharedUserProfile) => {
				this.currentUser = userProfile;
			});
	}

    public isHuronAdmin(): boolean {
        if (!this.currentUser) {
            return false;
        }

        return RoleUtil.isHuronAdmin(this.currentUser.roles);
    }

	// most of what is in this component isn't actually used currently but may be when/if the organization components stand alone
	// much of the logic resides in the ClientAdmin part and that makes sense since really the organization and client
	// are virtually the same objects in different databases for different applications

	onSubmit(e: Event|any): void {
		this.errorMessage = '';
		this._organizationService.saveOrganization(this.selectedOrganization).then((result) => {
			if (result === 0) {
				this.onCancelEdit();
			}
		});
	}

	showEditOrganizationError(editInput: HTMLInputElement): boolean {
			return !editInput.validity.valid;
	}

	validateForm(): boolean {
		return ((this.selectedOrganization.name != null && this.selectedOrganization.name.toString().trim().length > 0) &&
		((this.selectedOrganization.id >= 1) && (this.selectedOrganization.lemfyMonthStarting <= 12)) &&
		this.selectedOrganization.legacyLink != null && this.selectedOrganization.legacyLink.toString().trim().length > 0);
	}

	onCancelEdit() {
		this.cancelEdit.emit();
	}

	onEdited(): void
	{	
		this.isEdited.emit(true); 
	}	

	ngOnDestroy(): void {
		this.cancelEdit.unsubscribe();
		this.isEdited.unsubscribe();
		this._unsubscribe$.next();
		this._unsubscribe$.complete();
	}
}
